// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__ZizzF","title":"card_title__36TcM","inActive":"card_inActive__2VfoC"};